import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { RadioButtonGroupConfig } from 'src/app/model/radio-button/radio-button-group';
import { ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { ModalScroll } from 'src/app/shared';
import { Router } from '@angular/router';
import { MEDICAL_UW_URL } from 'src/app/shared/constants/medical-uw-url.constants';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-question-radio-button',
    templateUrl: './question-radio-button.component.html',
    styleUrls: ['./question-radio-button.component.scss'],
    imports: [NgClass]
})
export class QuestionRadioButtonComponent implements OnDestroy {
  @Input() config: RadioButtonGroupConfig;
  @Output() radioBtnClickHandler: EventEmitter<any> = new EventEmitter();
  @Output() blurHandler: EventEmitter<any> = new EventEmitter();
  @Input() defaultStyle;
  private subscriptn: Subscription;
  constructor(private btnFocusOnModalClose: ModalScroll, private router: Router) { }

  private lifestyleBtn: boolean = false;
  @Input() isbuttonViewChanged : boolean = false;


  ngOnDestroy() {
    if (this.subscriptn) {
    this.subscriptn.unsubscribe();
    }
  }


  radioBtnChangeHandler = (val) => {
    this.radioBtnClickHandler.emit(val);
  }

  /* common method for converting string into camel case */
  camelCase(id_value) {
    const format = /[ !@#$%^&£*()_+\-=\[\]{};':"\\|,.<>\/?]/;
    if (!format.test(id_value)) {
      return id_value.toLowerCase()
        // Replaces any - or _ characters with a space
        .replace(/[-_]+/g, ' ')
        // Removes any non alphanumeric characters
        .replace(/[^\w\s]/g, '')
        // Uppercases the first character in each group immediately following a space 
        // (delimited by spaces)
        .replace(/ (.)/g, function ($1) { return $1.toUpperCase(); })
        // Removes spaces
        .replace(/ /g, '');
    } else {
      return id_value;
    }
  }


  focusOnbtn() {
    this.subscriptn = this.btnFocusOnModalClose.scrollFlagState.subscribe(res => {
      if (res.btnFocus === true && document.querySelector('.btn-primary')) {
        (document.querySelector('.btn-primary') as HTMLElement).focus();
      }
    });
  }

  onBlurRadioButton(index, count) {
    if( index === count-1 ) {
      this.blurHandler.emit();
    }
  }


  getLabel(label) {
    if (label.length > 12 && (this.router.url === MEDICAL_UW_URL.annuitant.lifestyle || this.router.url === MEDICAL_UW_URL.dependant.dependantLifestyle)) {
      return true;
    } else {
      return false;
    }
  }
}
